<template>
    <div class="yypage">
        <div v-show="showPage==1" class="indexpage">
            <div class="logo flexCenter">
                <img :src="'./images/yy_img/home_logo.png'" alt="">
            </div>
            <div class="form flexCloumnSingleCenter">
                <van-field :disabled="true" label-class="label" v-model="EditItem.name" label="" placeholder=""/>
                <div class="underLine"></div>

                <van-field label-class="label" type="tel" v-model="EditItem.phone1" label="" placeholder="预约手机号码"/>
                <div class="underLine"></div>
            </div>
            <div class="tips flexEnd">
                <img :src="'./images/yy_img/home_icon.png'" alt="" @click="isShowModal=true">
                <span style="font-size: 14px;color: #00D1CB;" @click="isShowModal=true">预约须知</span>
            </div>

            <div class="submitBtn flexCenter">
                <div class="btn" @click="onSubmit">我要预约</div>
            </div>

            <!--预约须知-->
            <van-popup v-model="isShowModal" :close-on-click-overlay="false">
                <div class="modalImg">
                    <img :src="'./images/yy_img/home_modal2.png?r=2'" alt="">

                    <div class="pos flexCenter">
                        <div class="btn" @click="isShowModal=false,readRules=true">我已阅读</div>
                    </div>
                </div>
            </van-popup>
        </div>
        <div v-if="showPage==2" class="timepage">
            <div class="select flexAround">
                <div class="select1 flexStart" style="border: 0">
                    <van-icon name="chat"/>
                    <span style="font-weight: 700;margin-left: 6px;">校内咨询</span></div>
                <div class="select1">
                    <div class="flexStart">
                        <span @click="showPicker1 = true">{{ EditItem.advisory_data || '选择日期' }}</span>
                        <van-icon color="#1890ff" name="arrow-down" @click="showPicker1 = true"
                                  style="margin-left: 10px;"/>
                    </div>

                    <van-popup v-model="showPicker1" position="bottom" :close-on-click-overlay="false">
                        <van-picker :readonly="disabled" show-toolbar title="日期" :columns="dates"
                                    :default-index="defaultIndexDate" value-key="advisory_data"
                                    v-model="EditItem.advisory_data"
                                    @confirm="changePickerDate1" @cancel="showPicker1 = false"/>
                    </van-popup>

                </div>
            </div>


            <div class="timeblocks">
                <div class="blockItem flexCenter" v-for="(item,index) in timeBlocks" @click="checkBlock(item)">
                    <div>
                        <div class="time">{{ item.advisory_sta_data }}-{{ item.advisory_end_data }}</div>
                        <div v-show="false" class="yy flexCenter" style="margin-top: 2vh;">
                            <img :src="'./images/yy_img/time_icon.png'" alt="">
                            <span style="color: #00D1CB;margin-left: 4px;">{{ item.reservation_people }}</span>
                            <span style="margin-left: 4px;">/&nbsp;{{ item.reservation_people_number }}</span>
                        </div>
                    </div>
                    <div v-if="item.id==ckdId" class="checked"></div>
                    <div v-if="item.id==ckdId" class="thumbnail flexCenter">
                        <img :src="'./images/yy_img/time_checked.png'" alt="">
                    </div>
                    <div
                        v-if="((item.advisory_data<curDate)||(item.advisory_data==curDate&&(item.advisory_sta_data < curTime))||(item.reservation_people>=item.reservation_people_number))"
                        class="disabled"></div>

                </div>

            </div>

            <div class="submitBtn flexCenter">
                <div class="btn flexCenter" @click="onSubmitTime">预约</div>
            </div>

        </div>
        <div v-if="showPage==3" class="Formpage flexCloumnSingleCenter">
            <div class="form">
                <div class="extra flexBetween" style="margin-bottom: 3vh;">
                    <div>
                        <div class="topInfo">您预约的咨询日期为：{{ EditItem.advisory_data }}</div>
                        <div class="topInfo" style="margin-top: 10pxvh;">
                            咨询开始时间为：{{ EditItem.advisory_sta_data }}，咨询结束时间为：{{ EditItem.advisory_end_data }}
                        </div>
                    </div>
                    <i v-if="EditItem.id&&!disabled"
                       @click="onEditTime"
                       class="el-icon-edit-outline"
                       style="color: #00cfdc;font-size: 20px;font-weight: 700;"></i>
                </div>


                <van-field :readonly="disabled" v-model="EditItem.file_number" type="number" label="中考建档号：" required
                           placeholder="请输入建档号">
                    <template #right-icon>
                      <el-tag size="small" @click="showTips" effect="plain" type="danger">填写须知</el-tag>
                    </template>
                </van-field>
                <van-field :readonly="disabled" v-model="EditItem.exam_number" type="number" label="考试证号：" required
                           placeholder="请输入考试号">
                    <template #right-icon>
                      <el-tag size="small" @click="showTips" effect="plain" type="danger">填写须知</el-tag>
                    </template>
                </van-field>
                <van-field :readonly="disabled" v-model="EditItem.name" label="姓名：" required placeholder="请输入姓名"/>
                <van-field :readonly="disabled" class="childBox" name="checkbox" label="性别：" required>
                    <template #input>
                        <van-radio-group :disabled="disabled" :readonly="disabled" v-on:change="changeGender"
                                         v-model="EditItem.gender"
                                         direction="horizontal">
                            <van-radio name="1">男</van-radio>
                            <van-radio name="2">女</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <div class="flexBetween">
                    <van-field :readonly="disabled" v-model="EditItem.graduate_sch_city" label="所在地区：" required
                               placeholder="请选择" @click="()=>{if(!disabled){showPickerForm1 = true}}">
                        <template #input>
                            {{ EditItem.graduate_sch_city ? EditItem.graduate_sch_city : '请选择所在地区' }}
                        </template>
                    </van-field>
                    <van-icon name="arrow"/>
                    <van-popup v-model="showPickerForm1" position="bottom" :close-on-click-overlay="false">
                        <van-picker :readonly="disabled" show-toolbar title="地区" :columns="areaList"
                                    :default-index="defaultIndex" value-key="label"
                                    v-model="EditItem.graduate_sch_city1"
                                    @confirm="changeArea" @cancel="showPickerForm1 = false"/>
                    </van-popup>
                </div>

                <div class="flexBetween">
                    <van-field :readonly="disabled" v-model="EditItem.graduate_schname" label="毕业学校：" required
                               placeholder="请选择/填写"></van-field>
                    <van-tag v-if="!disabled" round type="primary" @click="()=>{if(!disabled){showPickerForm2 = true}}"
                             style="white-space: nowrap;display: flex;justify-content: center;align-items: center">
                        选择
                    </van-tag>
                    <van-popup v-model="showPickerForm2" position="bottom" :close-on-click-overlay="false">
                        <van-picker :readonly="disabled" show-toolbar title="学校" :columns="schools"
                                    :default-index="defaultIndexSchool" value-key="school_name"
                                    v-model="EditItem.graduate_schname1" @confirm="changeSchool"
                                    @cancel="showPickerForm2 = false"/>
                    </van-popup>
                </div>

                <!-- <van-field :readonly="disabled" v-model="EditItem.classid" type="digit" label="中考成绩："
                           required
                           :placeholder="AreaScore>0?'分数线:'+AreaScore:'只填数字'"/> -->
                <van-field :readonly="disabled" v-model="EditItem.contact_person1" label="联系人：" required
                           placeholder="请输入联系人"/>
                <van-field v-if="false" :readonly="disabled" v-model="EditItem.employer1" label="工作单位："
                           placeholder="请输入工作单位"/>
                <van-field :readonly="disabled" v-model="EditItem.phone1" type="tel" label="联系电话：" required
                           placeholder="请输入联系电话"/>

                <van-field :readonly="disabled" v-model="EditItem.contact_person2" label="联系人2："
                           placeholder="请输入联系人"/>
                <van-field v-if="false" :readonly="disabled" v-model="EditItem.employer2" label="工作单位："
                           placeholder="请输入工作单位"/>
                <van-field :readonly="disabled" v-model="EditItem.phone2" type="tel" label="联系电话："
                           placeholder="请输入联系电话"/>

                <van-field v-if="false" :readonly="disabled" class="childBox" name="checkbox" label="美术加试：">
                    <template #input>
                        <van-radio-group v-if="!disabled" :readonly="disabled" v-on:change="changeGender"
                                         v-model="EditItem.status"
                                         direction="horizontal">
                            <van-radio name="1">参加</van-radio>
                            <van-radio name="0">不参加</van-radio>
                        </van-radio-group>
                        <span v-if="disabled&&(EditItem.status===0||EditItem.status==='0')">不参加</span>
                        <span v-if="disabled&&(EditItem.status===1||EditItem.status==='1')">参加</span>
                        <span v-if="disabled&&EditItem.status!=0&&EditItem.status!=1">-</span>

                    </template>
                </van-field>

                <van-field v-if="false" :readonly="disabled" v-model="EditItem.award_certificate" autosize label="获奖证书："
                           type="textarea" placeholder="请输入获奖证书"/>


                <van-field :readonly="disabled" required class="childBox" name="checkbox" label="咨询人数：">
                    <template #input>
                        <van-radio-group v-if="!disabled" :readonly="disabled" v-on:change="changeCount"
                                         v-model="EditItem.advisory_count" direction="horizontal">
                            <van-radio name="1">1人</van-radio>
                            <van-radio name="2">2人</van-radio>
                            <van-radio name="3">3人</van-radio>
                        </van-radio-group>
                        <span v-if="disabled">{{ EditItem.advisory_count }}人</span>

                    </template>
                </van-field>
                <div class="flexCloumn" style="width: 100%;" v-if="false">
                    <div class="item-title flexStart">咨询内容：</div>
                    <div class="item-input">
                        <van-checkbox-group :disabled="disabled" :readonly="disabled" v-on:change="changeText"
                                            direction="horizontal"
                                            v-model="EditItem.advisory_text">
                            <van-checkbox name="专业咨询">专业咨询</van-checkbox>
                            <van-checkbox name="美术加试">美术加试</van-checkbox>
                            <van-checkbox name="专业面试">专业面试</van-checkbox>
                        </van-checkbox-group>
<!--                        <span v-if="disabled">{{ EditItem.advisory_text }}</span>-->
                    </div>
                    <div class="item-input item-input1">
                        提示：专业咨询（所有专业均勾选）<br/>
                        美术加试（动漫设计和数字媒体艺术设计必须勾选）<br/>
                        专业面试（婴幼儿托育服务与管理，商务英语，旅游管理专业必须勾选）

                    </div>
                </div>

                <div class="flexStart" style="width: 100%;" v-if="false">
                    <el-upload v-if="!disabled" :readonly="disabled" class="avatar-uploader" action=""
                               :http-request="uploadOss"
                               :on-success="uploadCover" :show-file-list="false" name="image">
                        <div v-if="EditItem.photo != ''" class="avatar flexCenter">
                            <img v-if="EditItem.photo != ''" :src="EditItem.photo" style="width: 100%">
                        </div>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip" style="width: 30vw;text-align: center;color: #909399">学生半身照
                        </div>

                    </el-upload>

                    <div v-if="disabled&&EditItem.photo != ''" class="avatar-uploader">
                        <div v-if="EditItem.photo != ''" class="avatar flexCenter">
                            <img v-if="EditItem.photo != ''" :src="EditItem.photo" style="width: 100%">
                        </div>
                        <div v-if="EditItem.photo != ''" slot="tip" class="el-upload__tip" style="width: 30vw;text-align: center;color: #909399">学生半身照</div>

                    </div>

                    <div :class="!disabled?'item-input1':'el-upload__tip item-input item-input1'" style="flex: 1;margin: 0">
                        提示：若咨询内容包含【美术加试】和【专业面试】,需要上传学生照片！
                    </div>

                </div>


            </div>

            <div v-if="!disabled" class="submitBtn flexCenter">
                <div class="btn" @click="onSubmitForm">确定</div>
            </div>
            <div v-if="disabled" class="submitBtn flexAround">
                <div class="btn" @click="onEdit" style="width: 40%;">更改内容</div>
                <div class="btn" @click="oncancelYY" style="width: 40%;">取消预约</div>
            </div>
        </div>

    </div>
</template>

<script>
import {
    Toast, Dialog
} from 'vant';

export default {
    data() {
        return {
            pmid: 4,
            openid: null,
            EditItem: {
                photo: '',
                advisory_count: '1',
                advisory_text: ['专业咨询'],
            },
            isShowModal: false,
            showPage: 1,
            readRules:false,
            //time
            showPicker1: false,
            timeBlocks: [],
            ckdId: null,
            curTime: '',
            curDate: '',
            dates: [],
            defaultIndexDate: 0,
            //Form
            showPickerForm1: false,
            showPickerForm2: false,
            //地区
            indexRegion: [null, null, null],
            optionRegion: [],
            arrRegion: [],
            areaList: [],
            defaultIndex: 0,
            //学校
            defaultIndexSchool: 0,
            schools: [],
            //图片
            imgList: [],
            uploadList: [], //上传图片缓冲数组
            uploadimgcount: 0, //要上传的图片数量
            alreadyUploadSuccessCount: 0, //已经上传的图片数量
            disabled: false,
			AreaScore:0,
			AreaScoreList:[]
        }
    },
    mounted() {
        $(".yypage").height($(window).height())//设置页面高度固定，防止输入法弹出页面变形，注意内部元素不能使用vh
        let _this = this
        //小程序传过来的参数 ?r=123&pmid=4&openid=123
        //r为随机数，不做处理

        this.pmid = this.$route.query.pmid
        this.openid = this.$route.query.openid
        // this.pmid = 4
        // this.openid = this.$route.query.openid ? this.$route.query.openid : 'oWsp85Bz3tDnWAC280W9bHMnUNcA'
        let myDate = new Date();
        let y = myDate.getFullYear().toString().padStart(2, "0");
        let m = (myDate.getMonth() + 1).toString().padStart(2, "0");
        let d = myDate.getDate().toString().padStart(2, "0");
        this.curDate = `${y}-${m}-${d}`

        let hh = myDate.getHours().toString().padStart(2, "0");
        let mm = myDate.getMinutes().toString().padStart(2, "0");
        let ss = myDate.getSeconds().toString().padStart(2, "0");
        this.curTime = `${hh}:${mm}`

        this.EditItem = {
            ..._this.EditItem
        }

        this.getDates()
        this.getArea()
        _this.getInfo()
		//this.getAreaMajorScoreLine()

    },
    methods: {
		getAreaMajorScoreLine(){
			this.$http.post("/api/get_area_major_score_line",{pmid:this.pmid}).then(res=>{
				this.AreaScoreList = res.data
			})
		},
        getInfo() {
            let _this = this
            return new Promise(resolve => {
                _this.$http.post("/api/interview_find_one", {
                    openid: _this.openid,
                    pmid: _this.pmid,
                }).then(function (res) {
                    if (res.data && res.data.id) {
                        if (res.data.advisory_text) {
                            let sparr = res.data.advisory_text.split(';')
                            for (let s = sparr.length - 1; s >= 0; s--) {
                                if(sparr[s]=='专业加试'){
                                    sparr[s]='美术加试'
                                }
                                if (!sparr[s]) {
                                    sparr.splice(s, 1)
                                }
                            }
                        // console.log(sparr)
                            res.data.advisory_text = sparr

                        }
                        _this.EditItem = res.data
                        _this.EditItem.gender = String(res.data.gender)
                        _this.EditItem.advisory_count = String(res.data.advisory_count)
                        _this.EditItem.status = String(res.data.status)

                        if (!_this.EditItem.contact_person2) {
                            _this.EditItem.contact_person2 = '-'
                        }
                        if (!_this.EditItem.phone2) {
                            _this.EditItem.phone2 = '-'
                        }


                        _this.ckdId = res.data.timeid
                        _this.showPage = 3
                        _this.disabled = true
                        _this.getAreaSchool()
                        resolve()

                    } else {
                        _this.showPage = 1
                        _this.disabled = false
                        resolve()

                    }
                })
            })
        },
        //	tools
        checkPhone(v) {
            let strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (strTemp.test(v)) {
                return true;
            }
            return false;
        },
        deleteEmptyGroup(treeData) {
            return new Promise(resolve => {
                function traversal(data) {
                    data.map(item => {
                        for (let info in item) {
                            if (item['children']) {
                                if (item['children'].length > 0) {
                                    traversal(item['children'])
                                }
                                if (item['children'].length == 0) {
                                    delete item['children']
                                }
                            }
                        }
                    })
                }

                traversal(treeData)
                resolve(treeData)
            })
        },
        //去重
        unique(data) {
            let _this = this
            let Array = [] //存放去重过后的数据
            let obj = {}
            //去除data,里面index相同的对象
            for (var i = 0; i < data.length; i++) {
                if (!obj[data[i].advisory_data]) {
                    Array.push(data[i])
                    obj[data[i].advisory_data] = true
                }
            }
            return Array
        },

        //index
        onSubmit() {
            // if (!this.EditItem.name) {
            //     Toast('请输入学生姓名');
            //     return
            // }
            if (!this.EditItem.phone1) {
                Toast('请输入学生或家长手机号码');
                return
            } else if (!this.checkPhone(this.EditItem.phone1)) {
                Toast('手机号格式不正确,请检查');
                return
            }
            if(!this.readRules){
                this.isShowModal=true
                return;
            }
            this.showPage = 2
			this.getAreaMajorScoreLine()
        },
        //获取当前日期
        getCurDate(val) {
            var myDate = val ? new Date(val) : new Date();
            let curTime = ''
            let year = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
            let month = this.timeAdd0(JSON.stringify(myDate.getMonth() + 1)); //获取当前月份(0-11,0代表1月)
            let date = this.timeAdd0(JSON.stringify(myDate.getDate())); //获取当前日(1-31)
            curTime = `${year}-${month}-${date}`
            return curTime
        },
        //自动补0
        timeAdd0(str) {
            if (str.length <= 1) {
                str = `0${str}`;
            }
            return str
        },
        changePickerDate1(e) {
            console.log(e)
            this.EditItem.advisory_data = e.advisory_data
            this.getTimeBlocks()
            this.showPicker1 = false
            // console.log(e,this.EditItem.advisory_data)

        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`
            } else if (type === 'day') {
                return `${val}日`
            }
            return val;
        },
        //time
        getDates() {
            let _this = this
            this.$http.post('/api/reservation_time_list', {
                pmid: this.pmid,
            }).then(res => {
                let dates = this.unique(res.data.data)
                let sortList = dates.sort((a, b) => {
                    return new Date(a.advisory_data) > new Date(b.advisory_data) ? 1 : -1;
                })

                let arr = []

                sortList && sortList.length > 0 && sortList.map(c => {
                    if (new Date(c.advisory_data) >= new Date(_this.curDate)) {
                        arr.push(c.advisory_data)
                    }
                })
                let minDate = arr[0]
                for (var i = 0; i < arr.length - 1; i++) {
                    minDate = new Date(minDate) > new Date(arr[i + 1].advisory_data) ? new Date(arr[i + 1]
                        .advisory_data) : minDate
                }
                // console.log(arr,minDate)
                sortList && sortList.length > 0 && sortList.map((e, ie) => {
                    if (e.advisory_data == minDate) {
                        this.defaultIndexDate = ie
                    }
                })
                this.dates = sortList
                this.EditItem.advisory_data = minDate
                this.getTimeBlocks()
            })
        },
        getTimeBlocks() {
            this.$http.post('/api/reservation_time_list', {
                pmid: this.pmid,
                advisory_data: this.EditItem.advisory_data,
            }).then(res => {
                this.timeBlocks = res.data.data
            })
        },
        checkBlock(item) {
            console.log(item)
            if (((item.advisory_data > this.curDate) ||
                ((item.advisory_data == this.curDate) && (item.advisory_sta_data > this.curTime))) &&
                (item.reservation_people < item.reservation_people_number)) {
                this.ckdId = item.id
                this.EditItem.timeid = item.id
                this.EditItem.advisory_sta_data = item.advisory_sta_data
                this.EditItem.advisory_end_data = item.advisory_end_data
                this.EditItem.reservation_people = item.reservation_people
            }

        },
        onSubmitTime() {
            if (!this.EditItem.timeid) {
                Toast('请选择预约时间段');
                return
            }
            this.showPage = 3
        },
        //Form
        getArea() {
            let _this = this
            return new Promise((resolve, reject) => {
                let provinceO = [],
                    cityO = [],
                    districtO = [];
                let provinceA = [],
                    cityA = [],
                    districtA = []
                this.$http.post("/api/sys_finish_school_area", {
                    pmid: _this.pmid
                }).then(function (res) {
                    if (res.data && res.data.length > 0) {
                        _this.deleteEmptyGroup(res.data).then(result => {
                            // console.log(res.data)
                            //地区初始化
                            provinceA = result
                            if (provinceA && provinceA.length > 0) {
                                provinceA.map((item, index, arr) => {
                                    provinceO.push(item.label)
                                })
                            }
                            cityA = provinceA[0].children
                            if (cityA && cityA.length > 0) {
                                cityA.map((item, index, arr) => {
                                    cityO.push(item.label)
                                })
                            }
                            districtA = cityA[0].children
                            if (districtA && districtA.length > 0) {
                                districtA.map((item, index, arr) => {
                                    districtO.push(item.label)
                                })
                            }
                            _this.optionRegion = [provinceO, cityO, districtO]
                            _this.arrRegion = [provinceA, cityA, districtA]


                            let setvalue = ["江苏省", "南京市", "玄武区"]
                            let colums = result
                            colums.map((a, ia) => {
                                if (a.label == setvalue[0]) {
                                    _this.defaultIndex = ia
                                }
                                a.children.map((b, ib) => {
                                    if (b.label == setvalue[1]) {
                                        a.defaultIndex = ib
                                    }
                                    b.children.map((c, ic) => {
                                        if (c.label == setvalue[2]) {
                                            c.defaultIndex = ic
                                        }

                                    })
                                })
                            })
                            _this.areaList = colums
                            // console.log(_this.areaList)
                            resolve()
                        })

                    }
                })
            })

        },
        getAreaSchool() {
            return new Promise(resolve => {
                this.$http.post("/api/app_area_school_list", {
                    dist_code: this.EditItem.graduate_dist_code,
                    pmid: this.pmid
                }).then(res => {
                    res.data.push({
                        id: 0,
                        school_name: "其他学校"
                    })
                    this.schools = res.data
                    res.data.map((a, ia) => {
                        if (a.id == this.EditItem.graduate_schid) {
                            this.defaultIndexSchool = ia
                        }
                    })
                    resolve()
                })
            })


        },
        changeArea(e, val) {
            let _this = this

            let provinceO = [],
                cityO = [],
                districtO = [];
            let provinceA = [],
                cityA = [],
                districtA = []
            // console.log(_this.areaList[val[0]])

            provinceA = _this.areaList
            if (provinceA && provinceA.length > 0) {
                provinceA.map((item, index, arr) => {
                    provinceO.push(item.label)
                })
            }
            cityA = provinceA[val[0]].children
            if (cityA && cityA.length > 0) {
                cityA.map((item, index, arr) => {
                    cityO.push(item.label)
                })
            }
            districtA = cityA[val[1]].children
            if (districtA && districtA.length > 0) {
                districtA.map((item, index, arr) => {
                    districtO.push(item.label)
                })
            }
            _this.optionRegion = [provinceO, cityO, districtO]
            _this.arrRegion = [provinceA, cityA, districtA]

            // console.log(e,val)
            this.EditItem.graduate_sch_city = e.join(',')
            this.EditItem.graduate_dist_code = this.arrRegion[2][val[2]].code

            this.EditItem = {..._this.EditItem}
            this.getAreaSchool()
            this.showPickerForm1 = false

			//检查分数线
			for(let p of this.AreaScoreList){
				for(let c of p.children){

					if(e[1]==c.area_name){
						this.AreaScore=c.score_line
						break
					}
				}
			}

        },
        changeSchool(e) {

            this.EditItem.graduate_schname = e.school_name


            this.showPickerForm2 = false
        },
        changeGender(e) {

        },
        uploadCover(e) {
            // console.log(e)
            this.EditItem.photo = e.src
        },
        changeCount(e) {

            this.EditItem.advisory_count = e
        },
        changeText(e) {

            this.EditItem.advisory_text = e
        },
        onSubmitForm() {
            let _this = this

        //    if(this.AreaScore>this.EditItem.exam_score){
		// 	   Toast('低于'+this.AreaScore+"分数线无法预约");
		// 	   return
		//    }
           this.EditItem.exam_score=0
            if (!this.EditItem.file_number) {
                Toast('中考建档号不能为空！');
                return
            }
            if (!this.EditItem.exam_number) {
                Toast('考试号不能为空！');
                return
            }
            if (!this.EditItem.name) {
                Toast('姓名不能为空！');
                return
            }
            if (!this.EditItem.gender) {
                Toast('性别不能为空！');
                return
            }
            this.EditItem.classid=0;
            // if(!this.EditItem.classid){
            //     Toast('中考成绩不能为空！');
            //     return
            // }
            if (!this.EditItem.graduate_sch_city) {
                Toast('所在地区不能为空！');
                return
            }
            if (!this.EditItem.graduate_schname) {
                Toast('毕业学校名不能为空！');
                return
            }

            if (!this.EditItem.contact_person1) {
                Toast('联系人1不能为空！');
                return
            }
            if (!this.EditItem.phone1) {
                Toast('联系人1手机号码不能为空！');
                return
            } else if (!this.checkPhone(this.EditItem.phone1)) {
                Toast('联系人1手机号格式不正确,请检查！');
                return
            }
            if (this.EditItem.phone2 && !this.checkPhone(this.EditItem.phone2)) {
                Toast('联系人2手机号格式不正确,请检查！');
                return
            }
            if (!this.EditItem.advisory_count) {
                Toast('咨询人数不能为空！');
                return
            }
            let finalArr = ['', '', '']
            if (this.EditItem.advisory_text && this.EditItem.advisory_text.length > 0) {
                let temp = ['专业咨询', '美术加试', '专业面试']
                this.EditItem.advisory_text.map(a => {
                    if (a == '专业咨询') {
                        finalArr[0] = '专业咨询'
                    }
                    if (a == '美术加试') {
                        finalArr[1] = '美术加试'
                    }
                    if (a == '专业面试') {
                        finalArr[2] = '专业面试'
                    }
                })

                console.log(finalArr)
            } else {
                Toast('咨询内容不能为空！');
                return
            }
            // if ((this.EditItem.advisory_text.indexOf('美术加试') != -1 || this.EditItem.advisory_text.indexOf('专业面试') != -1)
            //     && (!this.EditItem.photo || this.EditItem.photo == '')) {
            //     Toast('咨询内容若包含【美术加试】和【专业面试】,请上传学生照片！');
            //     return
            // }



            let params = {}
            params.file_number = this.EditItem.file_number
            params.exam_number = this.EditItem.exam_number
            params.name = this.EditItem.name
            params.gender = Number(this.EditItem.gender)
            params.classid = this.EditItem.classid
            params.graduate_sch_city = this.EditItem.graduate_sch_city
            params.graduate_schname = this.EditItem.graduate_schname
            params.contact_person1 = this.EditItem.contact_person1
            params.phone1 = this.EditItem.phone1
            params.contact_person2 = this.EditItem.contact_person2
            params.phone2 = this.EditItem.phone2
            params.advisory_count = Number(this.EditItem.advisory_count)
            params.timeid = this.EditItem.timeid
            params.graduate_dist_code = this.EditItem.graduate_dist_code
            graduate_dist_code: null
            params.photo = this.EditItem.photo

            params.advisory_text = finalArr.join(';')
            params.openid = this.openid
            params.pmid = this.pmid
            console.log(params)
            if (this.EditItem.id) {
                this.$http.post('/api/interview_appointment_delete', {
                    id: this.EditItem.id,
                    pmid: this.pmid
                }).then(res => {
                    this.requestForm(params)
                })
            } else {
                this.requestForm(params)
            }
        },
        requestForm(params) {
            let _this = this
            this.$http.post("/api/interview_appointment_edit", params).then(function (res) {
                if (res.data.id) {
                    Toast('预约成功！')
                    _this.EditItem = {}
                    _this.getInfo()

                } else {
                    Toast(res.data.msg)
                    _this.disabled = false
                }
            })

        },
        onEdit() {
            let _this = this
            // console.log(this.EditItem)
            if (_this.EditItem.contact_person2 == '-') {
                _this.EditItem.contact_person2 = ''
            }

            if (_this.EditItem.phone2 == '-') {
                _this.EditItem.phone2 = ''
            }
            this.disabled = false
        },
        onEditTime() {
            this.showPage = 2
        },
        oncancelYY() {
            let _this = this
            Dialog.alert({
                title: "是否确定取消预约？",
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "关闭",
                confirmButtonColor: '#00cfdc',
            }).then(() => {
                _this.$http.post('/api/interview_appointment_delete', {
                    id: _this.EditItem.id,
                    pmid: _this.pmid
                }).then(res => {
                    Toast('取消预约成功！')
                    _this.EditItem = {
                        photo: '',
                        advisory_count: '1',
                        advisory_text: ['专业咨询'],
                    }
                    _this.ckdId = null
                    _this.readRules=false
                    _this.getInfo()
                })

            }).catch(() => {
                console.log("点击了取消按钮噢")
            })
        },
        showTips(){
            let _this = this
            Dialog.alert({
                title: "提示",
                message:'南京市中考考生填报：建档号和考试证号以中考准考证为准。江苏其他地区中考考生填报：中考准考证上只有1个号码的，建档号和考证号填写相同的。中考准考证上有2个号码的，分别将2个号码依次填写到建档号和考证号中。',
                messageAlign:'left',
                showCancelButton: false,
                confirmButtonText: "关闭",
                confirmButtonColor: '#00cfdc',
            }).then(() => {
                console.log("点击了关闭按钮噢")


            }).catch(() => {
                console.log("点击了取消按钮噢")
            })
        },
    },
}
</script>

<style lang="less" type="text/less">
.van-radio__icon {
    font-size: 16px;
}

.van-radio__icon--checked .van-icon {
    background-color: #00cfdc;
    border-color: #00cfdc;
}

.van-checkbox__icon {
    font-size: 16px;
}

.van-checkbox__icon--checked .van-icon {
    background-color: #00cfdc;
    border-color: #00cfdc;
}

.van-tag--primary {
    background-color: #00cfdc;
}

.yypage {
    display: block;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

.indexpage {
    display: block;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-image: url(../../../../public/images/yy_img/home_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .logo {
        margin-top: 16.38vh;

        img {
            display: inline-block;
            width: 28.36vw;
            height: 11.95%;
        }
    }

    .form {
        margin-top: 8.78vh;
        padding: 0 15vw;

        .label {
            color: #A5A5A5;
            font-size: 14px;
            font-weight: 500;
        }

        .van-cell {
            background-color: transparent;

        }

        .underLine {
            width: calc(100% - 32px);
            border-bottom: 2px solid #fff;
        }

        .van-cell::after {
            border-bottom: 0;

        }
    }

    .tips {
        margin-top: 15px;
        padding: 0 15vw;

        img {
            display: inline-block;
            width: 15px;
            margin-right: 3px;
        }
    }

    .submitBtn {
        margin-top: 2vh;

        .btn {
            display: inline-block;
            padding: 1.4vh 8%;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 5vw;
        }
    }

    .van-popup {
        background-color: transparent;
    }

    .modalImg {
        display: inline-block;
        width: 74vw;
        position: relative;

        img {
            display: inline-block;
            width: 100%;
        }

        .pos {
            position: absolute;
            bottom: 2vh;
            width: 100%;

            .btn {
                display: inline-block;
                padding: 1.4vh 8%;
                background-color: #00CFDC;
                color: #fff;
                font-size: 15px;
                border-radius: 5vw;
            }
        }
    }
}

.timepage {
    display: block;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: hidden;
    background-image: url(../../../../public/images/yy_img/time_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .select {
        width: 100%;
        height: 16vh;

        .select1 {
            padding-bottom: 4px;
            border-bottom: 2px solid #1890ff;
        }
    }

    .timeblocks {
        width: 100%;
        height: 70vh;
        padding: 0 8vw;
        display: flex;
        box-sizing: border-box;
        overflow-y: scroll;
        justify-content: space-between;
        flex-wrap: wrap;

        .blockItem {
            width: 38vw;
            padding: 3vh 0;
            border: 1px solid #00CFDC;
            border-radius: 6px;
            margin-bottom: 3.37vh;
            background-color: #fff;
            box-shadow: 1px 1px 3.3px rgba(0, 0, 0, 0.36);
            position: relative;

            .time {
                color: #00D1CB;
                font-size: 19px;
                font-weight: 700;
            }

            .yy {
                color: #6E6E6E;
                font-size: 12px;

                img {
                    width: 13px;
                    height: 13px;
                }
            }
        }

        .checked {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #00CFDC;
            opacity: 0.5;
            border-radius: 6px;
        }

        .thumbnail {
            position: absolute;
            z-index: 2;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            img {
                display: inline-block;
                width: 23%;
            }
        }

        .disabled {
            position: absolute;
            z-index: 3;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: gray;
            opacity: 0.5;
            border-radius: 6px;
        }
    }

    .submitBtn {
        width: 100%;
        height: 10vh;

        .btn {
            width: 50%;
            padding: 1.4vh 0;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 5vw;
        }
    }
}

.Formpage {
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-image: url(../../../../public/images/yy_img/form_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 2.4vh 4% 4vh 4%;

    .form {
        flex: 1;
        width: 100%;
        overflow-y: scroll;
        border-radius: 8px;
        background-color: #fff;
        padding: 2vh 3%;
        box-sizing: border-box;

        .topInfo {
            color: #00D1CB;
            font-size: 12px;
        }

        .item-title{
            position: relative;
            box-sizing: border-box;
            width: 100%;
            padding: 10px 16px;
            font-size: 14px;color: #646566;
        }
        .item-title::before {
            position: absolute;
            left: 8px;
            color: #ee0a24;
            font-size: 14px;
            content: '*';
        }
        .item-input{
            position: relative;
            box-sizing: border-box;width: 100%;
            padding: 0 16px 10px 16px;
            font-size: 14px;color: #646566;
        }
        .item-input1{
            color: #ee0a24;
            font-size: 12px;
            line-height: 18px;
        }
        .item-input1::after {
            position: absolute;
            box-sizing: border-box;
            content: ' ';
            pointer-events: none;
            right: 16px;
            bottom: 0;
            left: 16px;
            border-bottom: 1px solid #ebedf0;
            -webkit-transform: scaleY(.5);
            transform: scaleY(.5);
        }
    }

    .submitBtn {
        margin-top: 6vh;
        width: 100%;

        .btn {
            display: inline-block;
            padding: 1.4vh 0;
            width: 60%;
            text-align: center;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 6px;
        }
    }
}

//上传头像
.avatar-uploader {
    //border-bottom: 1px solid #ebedf0;
    padding: 10px 16px;
}

.avatar-uploader .el-upload {
    //margin-top: 10px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 30vw;
    height: 30vw;
    line-height: 30vw;
    text-align: center;
}

.avatar {
    width: 30vw;
    height: 30vw;
    overflow: hidden;
}
</style>
